import className from '../../../common/className.js'
import {PACKING_LIST_SETTINGS_LINK} from '../../../common/constants/SettingsPanels.js'
import {useSelector} from '../../../store.js'
import Form from './Form.js'
import {
  selectedProfileTabSelector,
  settingsPackingListsIDSelector,
} from './packingListsFunctions.js'
import Icon from '../../../common/icons/Icon.js'

export default function EditForm({packingList}) {
  const id = useSelector(settingsPackingListsIDSelector)
  const selectedProfileTab = useSelector(selectedProfileTabSelector)

  const isExpanded = packingList.id === id
  const isDefault = packingList.is_default

  return (
    <li
      className={className`settings-list-item clearfix ${{
        expanded: isExpanded,
      }}`}
    >
      <div className="clearfix">
        <strong
          className={className`settings-list-item-title medium-5 columns ${{
            default: isDefault,
          }}`}
        >
          <span className="make-block warehouse-name-wrap">
            {isDefault && (
              <Icon
                name="check"
                className="warehouse-status-icon x-sm margin-right-1"
              />
            )}
            <span>{packingList.name}</span>
          </span>
          {isDefault && (
            <span className="make-block default-callout">
              <span>DEFAULT</span>
            </span>
          )}
        </strong>
        <span className="medium-2 columns end right-aligned-text right">
          <a
            className="inline-text-button settings-list-item-button edit-url"
            href={`${PACKING_LIST_SETTINGS_LINK}/${selectedProfileTab}/${packingList.id}`}
          >
            <Icon name="sym-edit" className="fs-01 margin-right-2" />
            <span className="button-text">Edit</span>
          </a>
        </span>
      </div>
      {isExpanded && <Form />}
    </li>
  )
}
